
// @mui
import { useTheme } from '@mui/material';
// components
import { IconButtonAnimate } from '../../../components/animate';
// config
import useAuth from 'src/hooks/useAuth';
import { useNavigate } from 'react-router';
import { PATH_AUTH } from 'src/routes/paths';
import SvgLogOut from 'src/components/icons/24/outlined/directions/log/LogOut';

// ----------------------------------------------------------------------

type IProps = {
  size?: any,
  color?: string

}

export default function LogoutPopover(props: IProps) {
  const { size, color } = props;
  const { logout } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();

  // const [open, setOpen] = useState<HTMLElement | null>(null);

  // const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
  //   setOpen(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setOpen(null);
  // };

  return (
    <>
      <IconButtonAnimate
        onClick={() => { logout(); navigate(PATH_AUTH.root) }}
        sx={{
          width: 40,
          height: 40,
          // ...(open && { bgcolor: 'action.selected' }),
        }}
      >
        <SvgLogOut color={color} size={size ? size : 'medium'} />
        {/* <LogoutIcon /> */}
      </IconButtonAnimate>

      {/* <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          mt: 1.5,
          ml: 0.75,
          width: 180,
          '& .MuiMenuItem-root': { px: 1, typography: 'body2', borderRadius: 0.75 },
        }}
      >
        <Stack spacing={0.75}>
          {allLangs.map((option) => (
            <MenuItem
              key={option.value}
              selected={option.value === allLangs[0].value}
              onClick={handleClose}
            >
              <Image
                disabledEffect
                alt={option.label}
                src={option.icon}
                sx={{ width: 28, mr: 2 }}
              />

              {option.label}
            </MenuItem>
          ))}
        </Stack>
      </MenuPopover> */}
    </>
  );
}
